import { render, staticRenderFns } from "./ExternalBudgetItemsEdit.vue?vue&type=template&id=04bb8c6a&scoped=true&"
import script from "./ExternalBudgetItemsEdit.vue?vue&type=script&lang=ts&"
export * from "./ExternalBudgetItemsEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bb8c6a",
  null
  
)

export default component.exports